import { VueModule } from '@Foundation/utilities';
import SpriteBackground from './code/Scripts/components/sprite-background';

export default VueModule({
  components: {
    SpriteBackground
  }
});
